<div class="loading-spinner" *ngIf="showLoading">
  <mat-spinner diameter="50" color="primary"></mat-spinner>
</div>
<router-outlet></router-outlet>
